import { makeStyles } from "tss-react/mui";

const useDrawerStyles = makeStyles()((theme) => ({
  container: {
    margin: "auto",
    width: "90%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    padding: `${theme.spacing(1)} 0`,
    color: theme.palette.text.primary,
  },
  lines: {
    "& > div:nth-of-type(odd)": {
      background: theme.palette.surface.bgNuanced2,
    },
    "& > div:nth-of-type(even)": {
      background: theme.palette.surface.light,
    },
  },
  root: {
    zIndex: 1400,
  },
  left: {
    fontWeight: 600,
    width: "50%",
  },
  right: {
    color: theme.palette.text.primary,
    fontWeight: 400,
    width: "50%",
  },
  words: {
    overflowWrap: "break-word",
    width: "98%",
  },
  paper: {
    height: "100%",
    padding: "8px",
    background: theme.palette.surface.darker,
  },
  closeButton: {
    textAlign: "right",
  },
  icon: {
    color: theme.palette.text.primary,
  },
 
  imageWrapper: {
    display: "flex",
    justifyContent: "center", 
    alignItems: "center",     
    margin: `${theme.spacing(1)} 0`, 
  },
  image: {
    maxWidth: "100%",    
    maxHeight: "300px",  
    objectFit: "contain", 
  },
}));

export default useDrawerStyles;
